
import styled from "styled-components/macro";



export const MessageBoxContainer = styled.div`
/* height: 50px; */
height: 15%;
background: black;
grid-area: box;

display: flex;
flex-direction: column; 
gap: .1em;

`


export const MessageBoxTop = styled.div`
/* padding:.25em; */
height:50%;
width: 100%;
/* font-size: .7rem; */

`
export const RebootAlert = styled.div`
width: 100%;
text-align: center;

background: #20fcf8; 
color: black; 
padding: ${({ landscape }) => (landscape ? "0" : ".25em")};
font-size: ${({ landscape }) => (landscape && ".7rem")};
`